import { Home } from "./pages/Home";
import { Live } from "./pages/Live";
import { Videos } from "./pages/Video";
import { Music } from "./pages/Music";
import { Bio } from "./pages/Bio";
import { Contact } from "./pages/Contact";
import { Footer } from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Home />
      <Live />
      <Videos />
      <Music />
      <Bio />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
